/**
 * Records the event page being viewed into localStorage, for the homepage's
 * "Pick up where you left off" strip.
 *
 * Written here (event pages, via the booking entrypoint), read by the inline
 * builder in platform/pages/_personal_strips.html.erb. The homepage is served
 * from a shared public cache, so this client-side trail is the only way it can
 * know what this visitor browsed — no cookies, no session, no extra requests.
 *
 * Entry shape: { slug, name, url, img, rating, reviews, ts } — the strip
 * builder validates each field before rendering, so adding fields is safe and
 * removing them is not.
 */
const KEY = 'tbRecentlyViewed';
const MAX = 12;

function record() {
  const tag = document.querySelector('[data-recent-event]');
  if (!tag) return;

  let entry;
  try {
    entry = JSON.parse(tag.textContent);
  } catch (e) {
    return;
  }
  if (!entry || !entry.slug || !entry.name || !entry.url || !entry.img) return;

  let items = [];
  try {
    items = JSON.parse(localStorage.getItem(KEY) || '[]');
  } catch (e) {
    // Corrupt store: start over rather than fail forever.
  }
  if (!Array.isArray(items)) items = [];

  items = items.filter((item) => item && item.slug !== entry.slug);
  items.unshift(Object.assign({}, entry, { ts: Date.now() }));

  try {
    localStorage.setItem(KEY, JSON.stringify(items.slice(0, MAX)));
  } catch (e) {
    // Storage full or blocked (private mode): the strip just stays empty.
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', record);
} else {
  record();
}
document.addEventListener('turbolinks:load', record);
document.addEventListener('turbo:load', record);
